import { render, staticRenderFns } from "./AuthorAvatarMenu.vue?vue&type=template&id=16fd4b44&scoped=true&"
import script from "./AuthorAvatarMenu.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAvatarMenu.vue?vue&type=style&index=0&id=16fd4b44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd4b44",
  null
  
)

export default component.exports